import React, { FunctionComponent } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { CustomInput } from "../../../CustomInput";
import { ISectionProps } from "../ISectionProps";
import { IMarlimarState } from "../../IState";
import { useNewInput } from "../../new-input.hook";
import { NewInputDialog } from "../NewInputDialog";
import { Button } from "../../../Button";

export const Marlimar: FunctionComponent<ISectionProps<IMarlimarState>> = (props): JSX.Element => {
    const {
        data,
        onChange
    } = props;

    const { isNewInputDialogOpen, toggleNewInputDialog } = useNewInput();

    return (
        <Box ml={2} mt={1} >
            <Typography sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 18, mb: 1 }} >
                Marlimar
            </Typography>
            <Box mt={2} display="flex" alignItems="center" flexWrap="wrap" gap={2}>
                <CustomInput
                    name="webhookAddress"
                    value={data.webhookAddress}
                    width={220}
                    height={35}
                    label={{ text: "Webhook Address", color: "rgba(0, 0, 0, 0.8)" }}
                    placeholder="webhook address"
                    onChange={props.onChange}
                />
                <CustomInput
                    name="hashKey"
                    value={data.hashKey}
                    width={220}
                    height={35}
                    label={{ text: "Hash Key", color: "rgba(0, 0, 0, 0.8)" }}
                    placeholder="hash key"
                    onChange={props.onChange}
                />
                {
                    props.fields.map((field, index) => {
                        const objName = Object.keys(field)[0] as keyof typeof field;

                        return (
                            <CustomInput
                                width={220}
                                height={35}
                                label={{ text: objName.toString() }}
                                name={objName.toString()}
                                value={field[objName]}
                                onChange={(event) => props.onChangeField(event as React.ChangeEvent<HTMLInputElement>, index)}
                            />
                        )
                    })
                }
            </Box>
            <Box mt={2} >
                <Button label="Add new field" width={120} height={35} onClick={toggleNewInputDialog} />
            </Box>
            <NewInputDialog
                open={isNewInputDialogOpen}
                onClose={toggleNewInputDialog}
                onClick={(name, value) => {
                    props.onAdd(name, value);
                    toggleNewInputDialog();
                }}
            />
        </Box>
    )
}